<template>
  <div id="footer" class="container-fluid">
    <div class="container">
      <div class="myfooter_l clearfix">
        <dl>
          <dt>中锐云</dt>
          <dd>
            <router-link to="/companyintroduction">关于我们</router-link>
          </dd>
          <dd>
            <router-link to="/software/naShui">公司产品</router-link>
          </dd>
        </dl>
        <dl>
          <dt>产品解决方案</dt>
          <dd>
            <router-link to="/software/naShui">1+N政务辅导生态系统</router-link>
          </dd>
          <dd>
            <router-link to="/software/zhiShui">政务问办一体化平台</router-link>
          </dd>
          <dd>
            <router-link to="/software/yeWu">业务精准提升平台</router-link>
          </dd>
          <dd>
            <router-link to="/software/animation">动画课件制作</router-link>
          </dd>
          <dd>
            <router-link to="/software/live">精品直播间</router-link>
          </dd>
          <dd>
            <router-link to="/software/5gkw">税企远程可视化交互平台</router-link>
          </dd>
        </dl>
      </div>
      <div class="myfooter_r">
        <div class="address clearfix">
          <i class="iconfont">&#xf070;</i>
          <div class="text">
            <p>公司地址</p>
            <p>深圳市福田区梅林街道奥士达路4号(奥士达大厦)A座2层A218</p>
          </div>
        </div>
        <div class="tel clearfix">
          <i class="iconfont">&#xf072;</i>
          <div class="text">
            <p>联系电话</p>
            <p>0755-8251-7005</p>
          </div>
        </div>
      </div>
    </div>
    <a href="https://beian.miit.gov.cn/#/Integrated/index" class="copy">Copyright &copy; 2010 - 2025 深圳中锐云科技有限公司&nbsp;版权所有&nbsp;粤ICP备11015879号</a>
  </div>
</template>
<script>
  export default {
    name: "Footer",
    data() {
      return {};
    }
  };

</script>
<style scoped>
  #footer {
    width: 100%;
    height: 100%;
    color: #fff;
    background: #303036;
    overflow: hidden;
    /* text-align: center; */
    padding: 50px 0 0;
  }

  .myfooter_l {
    width: 600px;
    float: left;
  }

  .myfooter_l dl {
    display: inline-block;
    margin-bottom: 30px;
  }

  .myfooter_l dl:last-child {
    margin-bottom: 0;
  }

  .myfooter_l dl dt {
    margin-bottom: 15px;
    text-align: left;
  }

  .myfooter_l dl dd {
    line-height: 34px;
    display: inline-block;
    margin-right: 20px;
  }

  .myfooter_l dl dd a {
    color: #cccccc;
  }

  .myfooter_l dl dd a:hover {
    color: #ffffff;
  }

  .myfooter_r {
    width: 450px;
    float: right;
    text-align: left;
    /* padding-right: 100px; */
  }

  .myfooter_r>div {
    margin-bottom: 36px;
  }

  .myfooter_r>div:last-child {
    margin-bottom: 0;
  }

  .myfooter_r i {
    display: block;
    float: left;
    font-size: 50px;
  }

  .myfooter_r .text {
    float: left;
    margin-left: 20px;
  }

  .myfooter_r .text p {
    line-height: 24px;
  }

  .copy {
    display: block;
    text-align: center;
    color: #333;
    background-color: #fff;
    font-size: 14px;
    padding: 10px 0;
    margin: 50px 0 0;
  }

  @media screen and (max-width: 997px) {
    .container {
      padding-left: 0;
    }
    #footer {
      /* text-align: center; */
      padding: 20px 0 0;
    }

    .myfooter_l {
      width: 100%;
      padding-left: 20px;
      /* float: left; */
    }

    .myfooter_l dl {
      display: block;
      margin-bottom: 20px;
      text-align: left;
      font-size: 14px;
    }

    .myfooter_l dl dt {
      margin-bottom: 10px;
      text-align: left;
    }

    .myfooter_l dl dd {
      line-height: 30px;
      display: inline;
      margin-right: 9px;
    }


    .myfooter_r {
      position: relative;
      top: 15px;
      font-size: 12px;
      float: none;
      padding-left: 20px;
    }

    .myfooter_r>div {
      margin-bottom: 20px;
    }

    .myfooter_r i {
      font-size: 40px;
    }


    .myfooter_r .text p {
      line-height: 20px;
    }

    .copy {
      font-size: 12px;
      margin: 30px 0 0px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue